import {
  FirstLastSummaryIndexDictionaryDto,
  OpmFirstLastWaterfallDictionaryDto,
} from '@app/shared/models/contracts/opm-calculation-results-dto';
import { l, translationKeys } from '@locale/setupI18n';
import { InstrumentValueKeys } from '../InstrumentCalculationsErf';
import CellValue from '@app/shared/components/cell-value/CellValue';
import {
  amountWithDecimalRules,
  amountRules,
} from '@app/shared/components/cell-value/CellValueConfigurations';
import classNames from 'classnames';
import styles from '@app/modules/projects/outputs/opm-summary-waterfall/opm-summary-waterfall-erf.module.scss';
import { simulationSectionsDefinition } from '../../helper/FirstLastHelpers';

interface InstrumentLevelRowProps {
  label: translationKeys;
  valueKey: keyof InstrumentValueKeys;
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto;
  selectedYear: string;
  waterfallIterations: number;
  instrumentKey: string;
  isBold?: boolean;
  decimalPoint?: number | null;
}

const InstrumentLevelRow: React.FC<InstrumentLevelRowProps> = ({
  label,
  valueKey,
  opmWaterfall,
  selectedYear,
  waterfallIterations,
  instrumentKey,
  decimalPoint = null,
  isBold = false,
}: InstrumentLevelRowProps) => {
  const hasValue = simulationSectionsDefinition.some((section) =>
    Object.entries(opmWaterfall[selectedYear][section]).some(
      ([key, _]) =>
        typeof (opmWaterfall[selectedYear][section] as FirstLastSummaryIndexDictionaryDto)[key]
          .instruments[instrumentKey][valueKey] === 'number'
    )
  );

  if (!hasValue) {
    return null;
  }

  return (
    <tr>
      <td
        className={classNames(styles['border-right'], { [styles['bold-text']]: isBold })}
        data-testid={`${valueKey}-instrument-title`}>
        {l(label)}
      </td>
      {simulationSectionsDefinition.map((section, outerIndex) =>
        Object.entries(opmWaterfall[selectedYear][section]).map(([key, _], innerIndex) => {
          const value = (opmWaterfall[selectedYear][section] as FirstLastSummaryIndexDictionaryDto)[
            key
          ].instruments[instrumentKey][valueKey];

          return (
            <td
              key={`${section}-${key}`}
              className={classNames({
                [styles['border-right']]:
                  outerIndex === 0 && innerIndex + 1 === waterfallIterations,
              })}
              data-testid={`${valueKey}-instrument-simulation-${key}`}>
              <CellValue
                value={value}
                {...(decimalPoint !== null ? amountWithDecimalRules : amountRules)}
              />
            </td>
          );
        })
      )}
    </tr>
  );
};

export default InstrumentLevelRow;
